var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_base_layer_group = function (in_implements, in_extends, options) {
    var implements = [];
    if (in_implements && in_implements.length) {
        implements = in_implements;
    } else {
        implements = [new Class(OCS.Viewer.Interfaces.LayerGroupInfo), new Class(OCS.Viewer.Interfaces.LayerGroupInit), new Class(OCS.Viewer.Interfaces.LayerGroupLayer), new Class(OCS.Viewer.Interfaces.LayerGroupLayerManipulation), new Class(OCS.Viewer.Interfaces.LayerGroupTime), new Class(OCS.Viewer.Interfaces.LayerGroupRequest)];
    }
    return new Class({
        Extends: OCS.Viewer.Functions.define_layer_group(implements, OCS.Viewer.Classes.AbstractLayer, options),
        class_name: "BaseLayerGroup",
        debug: false,
        options: {
            init_start_timestamp_epoch: 0,
            init_end_timestamp_epoch: 0,
            layer_class: "",
            layer_name: '',
            layer_short_name: '',
            layer_style_ops: {},
            layer_source_ops: {
                init: {
                },
                metadata: {
                    variables: []
                }
            },
            static: false,
            visible: false
        },
        bound_methods: {},
        init_timeout: null,
        post_init_timeout: null,
        initialize: function (op) {
            this.parent(op);
            this.set_ol_object(new ol.layer.Group());
            var group = this.get_ol_object();
            group.id = this.get_id();
            this.bound_methods.on_init = this.on_init.bind(this);
            this.bound_methods.on_post_init = this.on_post_init.bind(this);
            if (this.init_time) {
                this.init_time();
            }
            this.initialize_events();
        },
        initialize_events: function () {
            this.addEvent('init', this.bound_methods.on_init);
            this.addEvent('post_init', this.bound_methods.on_post_init);

            // Below are possible interfaces event initializations

            if (this.init_layer_events) {
                this.init_layer_events();
            }
            if (this.init_info_events) {
                this.init_info_events();
            }
            if (this.init_request_events) {
                this.init_request_events();
            }
            if (this.init_layer_manipulation_events) {
                this.init_layer_manipulation_events();
            }
            if (this.init_background_events) {
                this.init_background_events();
            }
            if (this.init_layer_group_legend) {
                this.init_layer_group_legend();
            }
            if (this.init_overlay_events) {
                this.init_overlay_events();
            }
            if (this.init_single_layer_events) {
                this.init_single_layer_events();
            }
            if (this.init_netcdf_events) {
                this.init_netcdf_events();
            }
            if (this.init_nids_events) {
                this.init_nids_events();
            }
            if (this.init_canvas_events) {
                this.init_canvas_events();
            }
        },

        //
        //
        // Event Fires
        //
        //

        init: function () {
            this.init_timeout = setTimeout(this.on_init_timeout.bind(this), 1);
        },
        post_init: function () {
            this.post_init_timeout = setTimeout(this.on_post_init_timeout.bind(this), 1);
        },
        //
        // Event listeners
        //
        on_init_timeout: function () {
            clearTimeout(this.init_timeout);
            this.init_timeout = null;
            this.fireEvent('init', null);
        },
        on_post_init_timeout: function () {
            clearTimeout(this.post_init_timeout);
            this.post_init_timeout = null;
            this.fireEvent('post_init', this);
        },
        on_init: function () {
            this.post_init();
        },
        on_post_init: function () {

        },

        remove_events: function () {
            this.remove_all_events();
            this.removeEvents();
            this.$events = {};
        },
        destroy: function () {
            this.fireEvent('destroy_layer_group', this);
            if (this.debug) {
                console.log('layer_group ' + this.get_layer_short_name() + ': Destroying ("' + this.get_layer_name() + '") group layer!!!');
            }
            this.options = {
                init_start_timestamp_epoch: 0,
                init_end_timestamp_epoch: 0,
                layer_class: "",
                layer_name: '',
                layer_short_name: '',
                layer_style_ops: {},
                layer_source_ops: {
                    init: {
                    },
                    metadata: {
                        variables: []
                    }
                },
                static: false,
                visible: false
            };
            this.remove_events();
            if (this.init_timeout) {
                clearTimeout(this.init_timeout);
                this.init_timeout = null;
            }
            if (this.post_init_timeout) {
                clearTimeout(this.post_init_timeout);
                this.post_init_timeout = null;
            }

            this.bound_methods = {};
        }
    });
};
OCS.Viewer.Classes.LayerGroup = OCS.Viewer.Functions.define_base_layer_group();